import {
  type CurrencyInputProps,
  Input as ChordsInput,
  type InputTextProps,
} from '~/chords/Input';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

const InputText = withClassNameHoc(ChordsInput.Text);

InputText.displayName = 'Input.Text';

const InputCurrency = withClassNameHoc(ChordsInput.Currency);

InputCurrency.displayName = 'Input.Currency';

export const Input = {
  Text: InputText,
  Currency: InputCurrency,
};

export type { CurrencyInputProps, InputTextProps };
